import { render, staticRenderFns } from "./NewUsersModal.vue?vue&type=template&id=c6022f66&"
import script from "./NewUsersModal.vue?vue&type=script&lang=js&"
export * from "./NewUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports